// src/components/EmailLinkBridge.js
import React, { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function EmailLinkBridge() {
  const navigate = useNavigate();
  const location = useLocation();

  const { isIOS, isChromeIOS, schemeUrl, continueWebUrl } = useMemo(() => {
    const ua = navigator.userAgent || '';
    const isiOS = /iPad|iPhone|iPod/.test(ua);
    const isCriOS = /\bCriOS\b/.test(ua); // Chrome en iOS
    const query = location.search || '';
    const scheme = `notemail://email-link-sign-in${query}`;
    const continueUrl = `/finishSignIn${query}`;
    return { isIOS: isiOS, isChromeIOS: isCriOS, schemeUrl: scheme, continueWebUrl: continueUrl };
  }, [location.search]);

  const handleOpenApp = () => {
    try {
      window.location.href = schemeUrl;
    } catch (_) {
      // Ignorar
    }
  };

  const handleContinueWeb = () => {
    navigate(continueWebUrl);
  };

  // Non-iOS: redirect to web flow directly
  if (!isIOS) {
    navigate(continueWebUrl);
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-50 p-4">
        <p className="text-gray-700">Redirecting...</p>
      </div>
    );
  }

  // iOS Safari: Universal Link should open the app; keep a manual button just in case
  if (isIOS && !isChromeIOS) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-50 p-4">
        <div className="text-center">
          <p className="text-gray-700 mb-4">Opening the app...</p>
          <button
            onClick={handleOpenApp}
            className="px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white text-lg rounded-lg shadow-md"
          >
            Open Notemail
          </button>
          <div className="mt-3">
            <button onClick={handleContinueWeb} className="text-sm text-gray-600 underline">
              Continue on the web
            </button>
          </div>
        </div>
      </div>
    );
  }

  // iOS Chrome: show button to open scheme and option to continue on web
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-50 p-4">
      <div className="text-center">
        <p className="text-gray-700 mb-4">To continue, open the Notemail app.</p>
        <button
          onClick={handleOpenApp}
          className="px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white text-lg rounded-lg shadow-md"
        >
          Open Notemail
        </button>
        <div className="mt-3">
          <button onClick={handleContinueWeb} className="text-sm text-gray-600 underline">
            Continue on the web
          </button>
        </div>
      </div>
    </div>
  );
}

export default EmailLinkBridge;


